import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 36 36" {...props}>
    <Path d="M0 0h36v36H0z" />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
